/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  ResultOfProposalViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfProposalViewModelFromJSON,
    ResultOfProposalViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface ProposalGetProposalAndClientRequest {
    proposalId?: number;
}

/**
 * 
 */
export class ProposalApi extends runtime.BaseAPI {

    /**
     * Get Proposal and client
     */
    async proposalGetProposalAndClientRaw(requestParameters: ProposalGetProposalAndClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfProposalViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['ProposalId'] = requestParameters.proposalId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v1/proposals`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfProposalViewModelFromJSON(jsonValue));
    }

    /**
     * Get Proposal and client
     */
    async proposalGetProposalAndClient(requestParameters: ProposalGetProposalAndClientRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfProposalViewModel> {
        const response = await this.proposalGetProposalAndClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
